var DynamicRegion = Marionette.Region.extend({
    constructor: function () {
        var self = this;
        Marionette.Region.prototype.constructor.apply(this, arguments);
        jQuery(this.$el).on(
            'hidden.bs.modal',
            function (event) {
                if (self.currentView && !self.currentView.isDestroyed) {
                    self.empty();
                }
            }
        );
        self.on('destroy empty', function () {
            jQuery(self.$el).modal('hide');
        });
    },
    onShow: function() {
        jQuery(this.$el).modal('show');
    }
});
module.exports = DynamicRegion;



/** WEBPACK FOOTER **
 ** ./assets/js/common/dynamic-region.js
 **/